import { ReactNode, useCallback, useEffect, useMemo, useState } from "react"
import Document, { IDocQueryParams } from "../../../../models/document"
import DocumentCard from "../../../../Components/molecule/cards/document-card"
import { viewDocument } from "slices/human-resources/thunk"
import { useDispatch } from "react-redux"
import { createSelector } from "reselect"
import { useSelector } from "react-redux"
import withRouter from "Components/Common/withRouter"
import { navigateToConsultantAgreement, navigateToGeneratedDocuments, navigateToGenerator } from "utils/navigator"
import DocuemntGeneratorSearchDocumentsTemplate from "Components/templates/hr/document-generator/search-documents-template"
import { DocumentGeneratorState, setDocumentTemplateValue } from "slices/human-resources/document-generator/reducer"
import { clearSearchFilters, getDocuments, setDocumentQueryValue } from "slices/human-resources/document-generator/thunk"
import { NavigateFunction } from "react-router-dom"
import useManual from "hooks/useManual"
import DataTableTemplate from "Components/templates/data-table-template"
import SearchDocumentsForm from "Components/organisms/forms/search-documents-form"
import { ColumnDef } from "@tanstack/react-table"
import useDataTable from "hooks/useDataTable"
import ActionButton from "Components/atoms/buttons/action-button"
import MicrosoftIcon from "Components/atoms/icons/microsoft-icon"
import { HelpIcon } from "Components/atoms/icons"

const selectDocumentGenerator = createSelector(
    (state: any) => state.DocumentGenerator,
    ({ docs, filters, doc }: DocumentGeneratorState) => ({
        docs, filters, doc
    })
)

const SearchDocumentPage = (props: any) => {
    document.title = "Search Documents | IbexIQ";
    const dispatch: any = useDispatch();
    const { handleOpenManual } = useManual("human-resources/document-generator");

    const { docs, filters, doc, } = useSelector(selectDocumentGenerator);

    // Handle clearing all filters
    const handleClear = () => {
        dispatch(clearSearchFilters());
    };


    useEffect(() => {
        const filterDocuments = async () => {
            dispatch(getDocuments(filters));
        };

        filterDocuments();
    }, [filters, getDocuments]);

    const handleFilterChange = (field: keyof IDocQueryParams, value: string) => {
        dispatch(setDocumentQueryValue(field, value));
    };

    // const handleViewDocument = async (document: Document) => {
    //     const viewUrl = await viewDocument(document.documentId);
    //     if (!viewUrl)
    //         return;

    //     window.open(viewUrl, "_blank")
    // }

    const handleNavigateToDoc = useCallback((router: NavigateFunction, documnetId: string, docCode?: string) => {
        if (doc && documnetId !== doc.id) {
            dispatch(setDocumentTemplateValue({}))
        }

        if (docCode === 'CONSULTANT_AGREEMENT') {
            navigateToConsultantAgreement(router, documnetId)
        } else {
            navigateToGenerator(router, documnetId)
        }
    }, [doc])

    const handleBack = useCallback(() => {
        navigateToGeneratedDocuments(props.router.navigate)
    }, [props.router.navigate])



    const columns = useMemo<ColumnDef<Document>[]>(() => [
        {
            id: "document",
            header: "Document",
            accessorFn: (row) => row.name,
            cell: ({ row }) => <div style={{ display: 'flex', gap: '10px' }}><MicrosoftIcon /> {row.original.name}</div>
        },
        {
            id: 'action',
            header: 'Action',
            enableSorting: false,
            meta: {
                getCellClassName: () => 'w-100 d-flex justify-content-end'
            },
            cell: ({ row }) => <ActionButton onClick={() => handleNavigateToDoc(props.router.navigate, row.original.id, row.original.code)}>Select</ActionButton>
        }
    ], [docs])

    const table = useDataTable({
        data: docs,
        columns,
        columnResizeMode: 'onEnd',
        enableColumnResizing: true,
    });

    return <DataTableTemplate
        title={"Human Resources"}
        breadcrumbItem={"Search Documents"}
        filters={<SearchDocumentsForm
            values={filters}
            onChange={handleFilterChange}
            handleClear={handleClear}
            handleBack={handleBack}
        />}
        table={table}
        actions={<>
            <ActionButton onClick={handleBack}>Back</ActionButton>
            <ActionButton onClick={handleOpenManual}>Help <HelpIcon /></ActionButton>
        </>}
        columns={columns}
        isLoading={false}
    />


}

export default withRouter(SearchDocumentPage)